import filterConstants from '../constants';

const reportsBudgetProject = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsBudgetProject,
  properties: {
    // [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    // [filterConstants.PROPERTY.assignee]: '',
  },
});

export default reportsBudgetProject;
